import React, { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import i18n from 'i18next';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAgent from '../../../common/hooks/useAgent';
import clientAgent from '../../agents/clientAgent';
import ClientEditionForm from '../form/ClientEditionForm';
import { Container } from '../../../common/components/layout';
import { ContainerLoader } from '../../../common/components/loaders';

const ClientEdition = ({ onBackClick }) => {
  const { id } = useParams();
  const [fetchClient, client, isFetchingClient] = useAgent(clientAgent.fetchClient);
  const [updateClient, updatedClient] = useAgent(clientAgent.updateClient);

  const handleSubmit = useCallback((values) => updateClient(id, values), [id, updateClient]);

  useEffect(() => {
    fetchClient(id);
  }, [fetchClient, id]);

  useEffect(() => {
    if (updatedClient) {
      toast.success(i18n.t('client.message.updateSuccess'));
      fetchClient(id);
    }
  }, [fetchClient, id, updatedClient]);

  if (!client || isFetchingClient) return <ContainerLoader />;

  return (
    <Container>
      <ClientEditionForm client={client} onBackClick={onBackClick} onSubmit={handleSubmit} />
    </Container>
  );
};

ClientEdition.propTypes = {
  onBackClick: PropTypes.func,
};

ClientEdition.defaultProps = {
  onBackClick: undefined,
};
export default ClientEdition;
